import React, { useState, useEffect, useLayoutEffect, useRef, Fragment } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu, InputGroup, InputGroupAddon } from 'reactstrap';

import Select, { components } from 'react-select';
import queryString from 'query-string'
import moment from "moment";
import { toast } from 'react-toastify';
import { cloneDeep, filter, isEmpty, isNil, reduce, startsWith } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import noImage from '../../assets/images/users/no-img.jpg';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import NavTab from '../../components/NavTab';
import { baseUrl } from '../../constants/environment';
import styled from 'styled-components';
import TextUtils from '../../helpers/TextUtils';
import { MySelectLoading } from '../../helpers/SelectAsync';
import ToggleButton from '../../common/ToggleButton';
import UserManager from '../../manager/UserManager';
import PhoneImageIcon from '../../assets/images/icon-phone.png';
import NumberFormat from 'react-number-format';
import AsyncSelect from "react-select/async";
import { AnyTxtRecord } from 'dns';
import { RenderActionModal } from './StockrequestList';
import ProductUtil from '../../helpers/ProductUtil';

interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}

const List = (props: any) => {
    const {from,dataFromExam, setDataFromExam, closeModal, fetchCustomerExam} = props
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(props?.match?.params?.id);
    const [onlyView, setOnlyView] = useState(false);
    const [data, setData] = useState({
        branch_id: props?.user?.branch_id?.id
    });
    const [product, setProduct] = useState<any>([{
        product_id: "",
        quantity: 1,
        unit_id:"",
    }])
    const [productTemplate, setProductTemplate] = useState<any>()
    const [modalIsOpen, setIsOpen] = useState(false);
    const [type, setType] = useState(props?.match?.params?.action);
    const [action, setAction] = useState();
    const [branch, setBranch] = useState<any>([]);
    const [history, setHistory] = useState<any>();
    const router = useHistory()

    const loadHistory = async (id:number) => {
        const url = `${baseUrl}/stock/request/history/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response?.data;
            setHistory(resData)
        }
    }


    useEffect(() => {
        if (id && id !== 'add') {
            loadData(id)
            document.title = 'Chỉnh sửa phiếu yêu cầu nhập hàng'
            
        }else{
            document.title = 'Thêm mới phiếu yêu cầu nhập hàng'
        }
        if (type === 'view') {
            setOnlyView(true)
            loadHistory(id)
            document.title = 'Chi tiết phiếu yêu cầu nhập hàng'
        }
    }, [id]);
    

    useEffect(() => {
        loadInit()
    }, []);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }
    
    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseBranch,
            responseProductTemplate
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/branch`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/product`, {...params, limit: 10}),
        ]);
        if (responseBranch.response?.data !== undefined) {
            let ListArr:any = [];
            responseBranch.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setBranch(ListArr)
        }
        if (responseProductTemplate.response?.data !== undefined) {
            const ListArr = ProductUtil.parseProduct(responseProductTemplate.response?.data)
            setProductTemplate(ListArr)
        }
    }
    

    const loadData = async (id:number) => {
        const url = `${baseUrl}/stock/request/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            if(!resData) router?.push(`/stockrequest/list`)
            const resDataProduct = response.response?.stock_request_products?.reduce((prev:any, item:any)=>{
                const product_units_lockup:any = {}
                product_units_lockup['root'] = {
                    name: item?.product_id?.minimum_unit,
                    quantity_conversion: 1,
                }
                item?.product_id?.product_units?.map((itemUnit:any)=>{
                    product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
                })
                const product_variants = item?.product_id?.product_variants
                const product_variants_units:any = ProductUtil.parseProductUnit(item?.product_id, product_variants, product_units_lockup)
                console.log("product_variants_units", item?.product_id)
                let itemRoot = {
                    name: item?.product_id?.name,
                    sku: item?.product_id?.sku,
                    stock_max: item?.product_id?.stock_max,
                    stock_min: item?.product_id?.stock_min,
                    type: item?.product_id?.type,
                    status: item?.product_id?.status,
                    height: item?.product_id?.height,
                    weight: item?.product_id?.weight,
                    width: item?.product_id?.width,
                    longs: item?.product_id?.longs,
                    vat: item?.product_id?.vat,
                    price: item?.product_id?.price,
                    price_import: item?.product_id?.price_import,
                    price_wholesale: item?.product_id?.price_wholesale,
                    product_id: item?.product_id?.id,
                    variant_id: null,
                    value: `${item?.id}`,
                    label: item?.product_id?.name,
                    units: product_variants_units,
                }
                if(item?.variant_id){
                    const itemVariant = item?.variant_id
                    const product_variants_units:any = ProductUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                    itemRoot = {
                        ...itemRoot,
                        name: itemVariant?.name,
                        sku: itemVariant?.sku,
                        vat: itemVariant?.vat,
                        price: item?.price,
                        price_import: itemVariant?.price_import,
                        price_wholesale: itemVariant?.price_wholesale,
                        product_id: item?.id,
                        variant_id: itemVariant?.id,
                        value: `${item?.id}-${itemVariant?.id}`,
                        label: itemVariant?.name,
                        units: product_variants_units,
                    }
                }
                prev = [...prev, {
                    product_id: item?.product_id?.id,
                    variant_id: item?.variant_id?.id,
                    product: itemRoot,
                    quantity: item?.quantity,
                    unit_id: item?.unit_id?.id || 0,
                }]
                return prev
            },[]);
            const dataTemp:any = {
                ...resData,
                branch_id: resData.branch_id?.id 
            }
            console.log("resDataProduct", resDataProduct)
            setData(dataTemp)
            setProduct(resDataProduct)
        }
    }

    return (
        <div style={{paddingBottom:50}}>
            <React.Fragment>
                {
                    !from &&
                    <PageTitle
                        breadCrumbItems={[
                            { label: `${type == 'view' ? 'Xem chi tiết' : id ? 'Chỉnh sửa' : 'Thêm mới'} phiếu yêu cầu nhập hàng`, active: true },
                        ]}
                        title={`${type == 'view' ? 'Xem chi tiết' : id ? 'Chỉnh sửa' : 'Thêm mới'} phiếu yêu cầu nhập hàng`}
                    />
                }
                <ContentPage 
                    data={data}
                    history={history}
                    setData={(val:any) => setData(val)}
                    branch={branch}
                    product={product}
                    productTemplate={productTemplate}
                    setProduct={(val:any) => setProduct(val)}
                    onlyView={onlyView}
                    id={id}
                    type={type}
                    action={action}
                    handleActionModal={(data:any) => handleActionModal(data)}
                    from={from}
                    closeModal={closeModal}
                    fetchCustomerExam={fetchCustomerExam}
                />
                <ModalPopup
                    isOpen={modalIsOpen}
                    onRequestClose={() => setIsOpen(false)}
                >
                    <RenderActionModal closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} refresh={()=>{
                        loadData(id)
                        loadHistory(id)
                    }} />
                </ModalPopup>
                {loading && <Loader />}
            </React.Fragment>
        </div>
    );
};

const ContentPage = (props:any) => {
    const {data,type, setData, branch, onlyView, id, setProduct, product, productTemplate, history, action, handleActionModal, 
    from} = props
    const [loading, setLoading] = useState(false)
    const router = useHistory()
    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone" || name === "guardian_phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        if(value?.length > 1000) return;
        setData({
            ...data,
            [name]: value
        })
    }

    const handleProductAdd = () => {
        const newDetailtiveUser = {
            product_id: "",
            variant_id: "",
            product: {},
            quantity:1,
        };
        setProduct([...product, newDetailtiveUser]);
    };

    const handleProductUpdate = (dataDetail: any, index: number) => {
        // check xem đã có sp kia trong danh sách chưa nha
        const checkIsset = product?.reduce((prev:any, item:any, indexCheck:number)=>{
            if(indexCheck !== index && item?.product_id === dataDetail?.product_id && item?.variant_id === dataDetail?.variant_id){
                prev = false
            }
            return prev
        }, true)
        if(!checkIsset){
            toast.warning('Sản phẩm đã được thêm')
            return
        }
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser[index] = dataDetail;
        setProduct(newDetailtiveUser);
    };

    const handleProductRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser.push({
            product_id: "",
            variant_id: "",
            product_info: {},
            quantity:1,
        })
        setProduct(newDetailtiveUser);
    };

    const validationFrom = () => {

        if (!data.branch_id) {
            toast.warning('Cơ sở (Kho) nhập không được để trống!');
            return false
        }
        const checkProduct = product?.reduce((prev:any, item:any)=>{
            if(
                !item?.product_id
                || !item?.quantity
            ){
                prev = false
            }
            return prev
        }, true)
        if (!checkProduct) {
            toast.warning('Nhập đầu đủ thông tin sản phẩm');
            return false
        }
        return true
    }
    
    const handleSubmit = async(is_draft?:boolean) => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/stock/request`;
        const stock_request_products = product?.reduce((prev:any, item:any)=>{
            prev = [...prev,{
                "product_id": item?.product_id,
                "variant_id": item?.variant_id || undefined,
                "quantity": item?.quantity,
                "unit_id": item?.unit_id ? item?.unit_id : undefined,
            }]
            return prev
        },[])
        const params = {
            "branch_id": data?.branch_id,
            "note": data?.note,
            "status": is_draft ? 0 : 1,
            "stock_request_products": stock_request_products
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo mới phiếu yêu cầu nhập hàng thành công')
            router?.push(`/stockrequest/${response.response?.id}/view`)
        }
    }

    const handleEdit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/stock/request/${id}`;
        const stock_request_products = product?.reduce((prev:any, item:any)=>{
            prev = [...prev,{
                "product_id": item?.product_id,
                "variant_id": item?.variant_id || undefined,
                "quantity": item?.quantity,
                "unit_id": item?.unit_id ? item?.unit_id : undefined,
            }]
            return prev
        },[])
        const params = {
            "branch_id": data?.branch_id,
            "note": data?.note,
            "stock_request_products": stock_request_products
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Chỉnh sửa phiếu yêu cầu nhập hàng thành công')
            router?.push(`/stockrequest/${response.response?.id}/view`)
        }
    }

    const getLabelStatus = (status:any) => {
        switch(status) {
            case -1: {
                return <span className="ml-2 label-status bg-danger">Từ chối</span>
                break;
            }
            case 0: {
                return <span className="ml-2 label-status bg-dark">Lưu nháp</span>
                break;
            }
            case 1: {
                return <span className="ml-2 label-status bg-success">Đã duyệt</span>
                break;
            }
            default: {
                return null
                break;
            }
        }
    }
      
    return (
        <PageContent style={from=='exam' ? {width:'900px', maxHeight:'80vh', overflowX:'hidden'}: {}} className={onlyView ? 'only-view' : ''}>
            <Row>
                <Col md={type === 'view' ? 8: 10} xs={12}>
                    <PageBody>
                        <div className="nutri-title mb-3">Thông tin phiếu yêu cầu nhập hàng {getLabelStatus(data?.status)}</div>
                        <Row>
                            
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Cơ sở (Kho) nhập</Label>
                                    <Select
                                        placeholder="Chọn cơ sở"
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        isDisabled={onlyView}
                                        onChange={(val: any) => {
                                            setData({ ...data, branch_id: val?.value })
                                        }}
                                        value={branch?.filter(
                                            (option: any) => data?.branch_id == option.value
                                        )}
                                        options={branch}
                                        components={{ Menu: (props:any)=>(
                                            <components.Menu {...props} >
                                                {props.children}
                                                <Link to="/setting/medicalbasis/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                                    <i className="uil-plus mr-1"></i> Tạo mới cơ sở
                                                </Link>
                                            </components.Menu>
                                        )}}
                                    ></Select>
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Mã phiếu yêu cầu nhập hàng</Label>
                                    <Input type="text" value={data?.code} onChange={(e: any) => handleChangeInput(e)} name="code" placeholder={(type=='view' && !data?.code) ? "---" : "Nhập mã phiếu"} />
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Ghi chú</Label>
                                    <Input type="text" value={data?.note} onChange={(e: any) => handleChangeInput(e)} name="note" placeholder={(type=='view' && !data?.note) ? "---" : "Nhập ghi chú"} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </PageBody>
                    <PageBody>
                        <div className="nutri-title mb-3">Sản phẩm</div>
                        <div className="table-responsive" style={{overflow: 'unset'}}>
                            <table className="mb-0 table-custom no-bg table table-input" >
                                <thead>
                                    <tr>
                                        <th style={{ width: '40%' }}><span className='require'>*</span> Tên sản phẩm</th>
                                        <th style={{ width: '20%' }}><span className='require'>*</span> Mã SKU</th>
                                        <th style={{ width: '20%' }}><span className='require'>*</span> Đơn vị</th>
                                        <th style={{ width: '20%' }}><span className='require'>*</span> Số lượng</th>
                                        {!onlyView &&<th style={{ width: '6%' }}></th>}
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    product?.map((item:any, index:number) => (
                                        <ProductItem 
                                            detailIndex={index} 
                                            data={item}
                                            onChangeData={(dataDetail: any) =>
                                                handleProductUpdate(dataDetail, index)
                                            }
                                            productTemplate={productTemplate}
                                            type={type}
                                            onlyView={onlyView}
                                            handleRemoveData={() => handleProductRemove(index)}
                                            handleAddData={() => handleProductAdd()}
                                            detail={product}
                                        />
                                    ))
                                }
                                </tbody>
                            </table>
                        </div>
                        
                    </PageBody>
                </Col>
                <Col md={type === 'view' ? 4: 2} xs={12}>
                   {type === 'view' && <History history={history}/>}
                </Col>
            </Row>
           
            {
                // !from &&
                <div className="bottom-action">
                    <Button color="success" className='success-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                    {
                        !id && <>
                            <Button color="info" className='ml-2' onClick={()=>handleSubmit(true)}>Lưu nháp</Button>
                            <Button color="success" className='ml-2' onClick={()=>handleSubmit()}>Tạo và duyệt</Button>
                        </>
                    }
                    {
                        id && type == 'view' && data?.status == 0 && 
                        <>
                            <Button color="success" className='ml-2' onClick={() => props?.handleActionModal({type: 'active', data: data})}>Duyệt</Button>
                            <Button color="success" className='danger-bland ml-2' onClick={() => props?.handleActionModal({type: 'reject', data: data})}>Từ chối</Button>
                            <Button color="success" className='ml-2' onClick={() => router?.push(`/stockrequest/${id}`)}>Chỉnh sửa</Button>
                        </>
                    }
                    {
                        id && type == 'view' && data?.status == 1 && 
                        <>
                            <Button color="success" className='ml-2' onClick={() => props?.handleActionModal({type: 'import', data: data})}>Nhập hàng</Button>
                        </>
                    }
                    {
                        id && type != 'view' &&
                        <Button color="success" className='ml-2' onClick={handleEdit}>Lưu</Button>
                    }
                </div>
            }
            
            {loading && <Loader />}
        </PageContent>
    )
}

const History = (props:any)=>{
    const {history} = props
    
    const HistoryItem = ({item}:any)=>{
        if(item?.import_status === 0){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Tạo mới nhập hàng</td>
                </tr>
            )
        }else if(item?.import_status === 1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Xác nhận nhập hàng</td>
                </tr>
            )
        }else if(item?.import_status === 2){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Nhập kho</td>
                </tr>
            )
        }else if(item?.import_status === 3){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Chuyển hoàn</td>
                </tr>
            )
        }else if(item?.import_status === -1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Hủy nhập hàng</td>
                </tr>
            )
        }else if(item?.status === -1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Từ chối</td>
                </tr>
            )
        }else if(item?.updated_uid && item?.status === 1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Duyệt</td>
                </tr>
            )
        }else if(item?.updated_uid){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Cập nhật</td>
                </tr>
            )
        }else if(item?.status === 1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Tạo và duyệt</td>
                </tr>
            )
        }else if(item?.status === 0){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name || item?.created_uid?.name}</td>
                    <td>Lưu nháp</td>
                </tr>
            )
        }
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name}</td>
                <td>Tạo mới</td>
            </tr>
        )
    }


    return(
        <PageBody>
            <div className="nutri-title mb-3">Lịch sử thao tác</div>
            <div className="table-responsive" style={{overflow: 'unset'}}>
                <table className="mb-0 table-custom no-bg table table-input" >
                    <thead>
                        <tr>
                            <th style={{ width: '30%' }}>Thời gian</th>
                            <th style={{ width: '30%' }}>Người thực hiện</th>
                            <th style={{ width: '30%' }}>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        history?.map((item:any, index:number) => (
                            <HistoryItem 
                                item={item}
                            />
                        ))
                    }
                    </tbody>
                </table>
            </div>
            
        </PageBody>
    )
}

const ProductItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, productTemplate, type, onlyView, handleRemoveData, handleAddData} = props
    const [loadingDesignation, setLoadingProduct] = useState(false);
    const [queryDesignation, setQueryDesignation] = useState('')

    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        onChangeData({
            ...data,
            [name]: value
        })
    }

    const loadProduct = async () => {
        setLoadingProduct(true)
        let response: any = await APIClient.GET(`${baseUrl}/product`,{
            page: 1,
            limit: 100,
            name: queryDesignation
        });
        setLoadingProduct(false)
        if (response.response?.data !== undefined) {
            const ListArr = ProductUtil.parseProduct(response.response?.data)
            return ListArr
        }else{
            return []
        }
    };

    const handleInputChangeProduct = (newValue:any) => {
        setQueryDesignation( newValue);
        return newValue;
    };

    return (
        <tr>
            <td>
                <AsyncSelect
                    className="react-select"
                    classNamePrefix="react-select"
                    onInputChange={handleInputChangeProduct}
                    loadOptions={loadProduct}
                    inputValue={queryDesignation}
                    placeholder={loadingDesignation ? "Đang tải dữ liệu..." : "Nhập tên, mã sản phẩm"}
                    noOptionsMessage={() => queryDesignation ? "Không tìm thấy dữ liệu" : 'Nhập tên, mã sản phẩm'}
                    loadingMessage={() => 'searching...'}
                    styles={customStyles}
                    cacheOptions 
                    defaultOptions={productTemplate}
                    onChange={(val: any) => {
                        console.log("AsyncSelect", {
                            ...data,
                            product_id: val?.product_id,
                            variant_id: val?.variant_id || undefined,
                            product: val,
                            unit_id: 0,
                            quantity: 1,
                        })
                        onChangeData({
                            ...data,
                            product_id: val?.product_id,
                            variant_id: val?.variant_id || undefined,
                            product: val,
                            unit_id: 0,
                            quantity: 1,
                        })
                    }}
                    // value={productTemplate?.filter(
                    //     (option: any) => data?.product_id == option.product_id && data?.variant_id == option.variant_id
                    // )}
                    value={{
                        label: data?.product?.name
                    }}
                    // menuPlacement="top"
                    isDisabled={onlyView}
                    components={{ Menu: (props:any)=>(
                        <components.Menu {...props} >
                            {props.children}
                            <Link to="/product/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                <i className="uil-plus mr-1"></i> Tạo mới sản phẩm
                            </Link>
                        </components.Menu>
                    )}}
                />
            </td>
            <td>
                <Input type="text" value={data?.product?.sku || ''} disabled={true} placeholder={(type=='view' && !data?.product?.sku) ? "---" : "Mã SKU"} />
            </td>
            <td>
                <Select
                    placeholder={(type=='view' && !data?.unit_id) ? "---" : "Chọn đơn vị..."}
                    className="react-select"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                        onChangeData({
                            ...data,
                            unit_id: val?.value,
                        })
                    }}
                    value={data?.product?.units?.filter(
                        (option: any) => data?.unit_id == option.value
                    )}
                    options={data?.product?.units}
                ></Select>
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => handleChangeData({ target: { name: 'quantity', value: TextUtils.onlyNumber(e.target.value) } })}
                    name={'quantity'} type={'text'} className="form-control" 
                    value={type === 'view' && !data?.quantity ? '---': data?.quantity}
                    disabled={onlyView}
                    placeholder={(type=='view' && !data?.quantity) ? "---" : "Nhập số lượng..."} thousandSeparator={true} 
                />
            </td>
            {!onlyView &&
            <td>
                {/* <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button> */}
                {
                    detail?.length == detailIndex+1 ?
                    <Button onClick={handleAddData} className='nutri-square' color='success'><i className='uil-plus'></i></Button> :
                    <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                }
            </td>}
        </tr>
    )
}

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
      }),
  };

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

export default connect(mapState)(List)